import {authHeader} from '../_helpers'
import axios from 'axios'

export const serviceService = {
  searchServices,
  createService,
  getService,
  updateService,
  deleteService
}

function createService (service) {
  return axios.post(process.env.BASE_URL + '/api/service', service, {headers: authHeader()})
}

function getService (serviceId) {
  return axios.get(process.env.BASE_URL + '/api/service/' + serviceId, {headers: authHeader()})
}

function updateService (service) {
  return axios.put(process.env.BASE_URL + '/api/service/' + service.id, service, {headers: authHeader()})
}

function deleteService (serviceId) {
  return axios.delete(process.env.BASE_URL + '/api/service/' + serviceId, {headers: authHeader()})
}

function searchServices (searchTerms, page, size) {
  if (page !== undefined && size !== undefined) {
    return axios.post(process.env.BASE_URL + '/api/service/search?page=' + page + '&size=' + size, searchTerms, {headers: authHeader()})
  } else {
    return axios.post(process.env.BASE_URL + '/api/service/search', searchTerms, {headers: authHeader()})
  }
}



// WEBPACK FOOTER //
// ./src/_services/service-service.js